import { Breadcrumbs } from "@/shared/components/layout/Breadcrumbs";
import { PageHeader } from "@/shared/components/layout/PageHeader";
import { DataTable } from "@/shared/components/table";
import { WorkspaceSearchFormCard } from "../components/WorkspaceSearchFormCard";
import { useWorkspaceSearch } from "../hooks/useWorkspaceSearch";
import { useWorkspaceSearchColumns } from "../hooks/useWorkspaceSearchColumns";

export function InfoWorkspaceSearchPage() {
  const vm = useWorkspaceSearch();
  const columns = useWorkspaceSearchColumns();

  return (
    <div className="space-y-6">
      <Breadcrumbs />
      <PageHeader title="워크스페이스 조회" description="엑스퍼트 워크스페이스를 조회합니다." />

      <WorkspaceSearchFormCard
        orgId={vm.form.orgId}
        onOrgIdChange={vm.form.setOrgId}
        channel={vm.form.channel}
        onChannelChange={vm.form.setChannel}
        dwAccountId={vm.form.dwAccountId}
        onDwAccountIdChange={vm.form.setDwAccountId}
        onSubmit={vm.submit}
        disabled={!vm.canSubmit || vm.isLoading}
      />

      <DataTable
        columns={columns}
        data={vm.pagedRows}
        totalCount={vm.totalCount}
        page={vm.page}
        pageSize={vm.pageSize}
        onPageChange={vm.setPage}
        onPageSizeChange={vm.setPageSize}
        isLoading={vm.isLoading}
        isError={vm.isError}
      />
    </div>
  );
}